"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryEncryption_1 = require("./_InventoryEncryption");
exports._InventoryS3BucketDestination = {
    type: "structure",
    required: ["Bucket", "Format"],
    members: {
        AccountId: {
            shape: {
                type: "string"
            }
        },
        Bucket: {
            shape: {
                type: "string"
            }
        },
        Format: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Encryption: {
            shape: _InventoryEncryption_1._InventoryEncryption
        }
    }
};
//# sourceMappingURL=_InventoryS3BucketDestination.js.map